export default __webpack_public_path__ + "static/media/metakat.8cade433.png";